module.exports = __webpack_public_path__ + "static/fonts/355CC9_0_0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_0_0.ttf
// module id = 14
// module chunks = 0